























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Input extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly required!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly valid!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly empty!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly shrinked!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly showMarks!: boolean;

  @Prop({ type: String, default: "" })
  readonly error!: string;

  @Prop({ type: String, default: "Заполните это поле" })
  readonly placeholder!: string;

  @Prop({ type: String, default: "" })
  readonly name!: string;
}
